import { Drawer } from "antd";
import { useEffect, useState } from "react";
import ContentBill from "./ContentBill";

function Bill({
  onClose,
  visible = false,
  data = {},
  storeInfo = [],
  storeId = [],
  setconfirmationModal,
}) {
  const [width, setWidth] = useState(window.innerWidth);
  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <Drawer
      placement="right"
      width={width > 768 ? "40%" : "100%"}
      closable={onClose}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ padding: "0" }}
    >
      {data != null && (
        <ContentBill
          data={data}
          storeInfo={storeInfo}
          storeId={storeId}
          visible={visible}
          setconfirmationModal={setconfirmationModal}
        />
      )}
    </Drawer>
  );
}

export default Bill;
